import React, { useState } from 'react'
import { Button } from '@mui/material'
import SyntaxDebugger from './SyntaxDebugger'
import PhraseDebugger from './PhraseDebugger'
import { useTranslation } from 'react-i18next'

const DebugViewer = () => {
  const { t } = useTranslation()

  const [showData, setShowData] = useState(true) // show by default if dev mode is enabled

  return (
    <>
      <PhraseDebugger />
      {/* Button to toggle data table visibility */}
      <Button
        variant="contained"
        color="secondary"
        onClick={() => setShowData(!showData)}
        fullWidth
      >
        {showData ? t('hideData') : t('showData')}
      </Button>
      {/* Conditionally show the data tables */}
      {showData && <SyntaxDebugger />}
    </>
  )
}

export default DebugViewer
